import { Text } from "./text";

export { Text };
export type * from "./text";
